import EmailAlertsFooter from './EmailAlertsFooter';

export default EmailAlertsFooter;
